// Custom charts: a spec in either grammar (Vega-Lite or full Vega), bound to
// the host's dataset, validated, themed, sandboxed and sized to its host.
// A separate entry point (`@erp/viz/custom`) because validation carries the
// Vega JSON schema — only surfaces that render Custom charts should load it.
export type {
  CustomChartGrammar,
  CustomChartSpec,
  JsonObject,
} from "./types.js";
export { VEGA_DATASET_NAME } from "./types.js";
export { validateCustomChart } from "./validate.js";
export type { CustomChartValidation } from "./validate.js";
export { stripHostControlledKeys } from "./hostKeys.js";
export { bindDataset } from "./dataBinding.js";
export { fitToHost } from "./fitToHost.js";
export type { HostSize } from "./fitToHost.js";
export { createBlockedLoader, ChartLoadBlockedError } from "./loader.js";
export {
  buildRuntimeChart,
  renderCustomChartHeadless,
  verifyCustomChartRenders,
  SAFE_VIEW_OPTIONS,
} from "./runtime.js";
export type {
  RuntimeChart,
  HeadlessRenderOptions,
  RenderProof,
} from "./runtime.js";
export { VEGA_CORPUS } from "./corpus.js";
export type { VegaCorpusEntry } from "./corpus.js";
export { CustomChart } from "./CustomChart.js";
export type { CustomChartProps } from "./CustomChart.js";
